import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  apiGetCall,
  // apiPostCall,
  // apiPutCall,
  apiDeleteCall,
  apiPostCallWithFullError,
  apiPutCallWithFullError,
} from "../api";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  fetchPayment,
  fetchPaymentSuccess,
  fetchPaymentFailure,
  addNewMarket,
  addNewMarketSuccess,
  addNewMarketFailure,
  putPayment,
  putPaymentSuccess,
  putPaymentFailure,
  fetchPos,
  fetchPosSuccess,
  fetchPosFailure,
  fetchFop,
  fetchFopSuccess,
  fetchFopFailure,
  addNewFop,
  addNewFopSuccess,
  addNewFopFailure,
  addNewPos,
  addNewPosSuccess,
  addNewPosFailure,
  deletePayment,
  deletePaymentSuccess,
  deletePaymentFailure,
  fetchAffectedItems,
  fetchAffectedItemsSuccess,
  fetchAffectedItemsFailure,
  deletePOS,
  deletePOSFailure,
  deletePOSSuccess,
  fetchFopAffectedItems,
  fetchFopAffectedItemsSuccess,
  fetchFopAffectedItemsFailure,
  deleteFOP,
  deleteFOPSuccess,
  deleteFOPFailure,
  fetchHistory,
  fetchHistorySuccess,
  fetchHistoryFailure,
} from "../slices/paymentSlice";
import {
  setNotification,
  resetAppLoading,
  setAppLoading,
} from "../slices/notificationSlice";

const URL = process.env.REACT_APP_API_URL;
const errorMessages = {
  400: "Invalid entry.",
  409: "Entry already exists.",
  500: "An error occurred, please try again.",
  405: "An error occurred, please try again.",
  404: "Not found",
};

function* checkTokenExpired() {
  yield window.instance
    .acquireTokenSilent({
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
      authority: process.env.REACT_APP_AZURE_AUTHORITY,
    })
    .then((res) => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.idToken}`;
    })
    .catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        window.instance.loginRedirect();
      }
    });
}

function* fetchPaymentSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    // yield put(fetchPayment());

    const response = yield call(apiGetCall, `${URL}admin/payment-catalogues`);

    yield put(fetchPaymentSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchPaymentFailure());
    yield put(
      setNotification({
        message: "Unable to fetch payment catalogues.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* addNewMarketSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    const modalData = action.payload;
    const sellerTypeMap = {
      AG: "agency",
      CR: "consumer",
    };
    const newMarketData = {
      sellerType: sellerTypeMap[modalData.sellerType] || modalData.sellerType,
      pos: modalData.pos,
      cash: modalData.cash === "enabled" ? "TRUE" : "FALSE",
      eligibleFOP: modalData.fop,
      comment: modalData.comment,
    };

    const response = yield call(
      apiPostCallWithFullError,
      URL + `admin/payment-catalogue`,
      newMarketData
    );
    if (response.status === "successful") {
      yield put(addNewMarketSuccess(response.data));
      yield put(
        setNotification({
          message: "New market added successfully!",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchPayment());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.error("Error adding new market:", error);
    yield put(addNewMarketFailure());

    const errorCode = error.response.status;
    console.log(errorCode);
    if (
      errorCode &&
      errorCode === 403 &&
      error.response.data.ErrorCode === "403-SU"
    ) {
      // Support users access pending for the action.
      yield put(
        setNotification({
          message:
            "Access denied! Support user access is pending for the action performed.",
          severity: "error",
          open: true,
        })
      );
    } else {
      yield put(
        setNotification({
          message: "Something went wrong. Try again!",
          severity: "error",
          open: true,
        })
      );
    }
  } finally {
    yield put(resetAppLoading());
  }
}

function* putPaymentCatalogueSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    const reqData = action.payload;
    console.log("reqData", reqData);

    const editMarketData = {
      sellerType: reqData.sellerType,
      pos: reqData.pos,
      cash: reqData.cash === "enabled" ? "TRUE" : "FALSE",
      eligibleFOP: reqData.fop,
      comment: reqData.comment,
    };

    const response = yield call(
      apiPutCallWithFullError,
      `${URL}admin/payment-catalogue/${reqData.id}`,
      editMarketData
    );
    console.log("response", response);

    if (response.status === "successful") {
      yield put(putPaymentSuccess(reqData));
      yield put(
        setNotification({
          message: "Market edited successfully!",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchPayment());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.error("Error updating payment catalogue:", error);
    yield put(putPaymentFailure());

    const errorCode = error.response.status;
    console.log(errorCode);
    if (
      errorCode &&
      errorCode === 403 &&
      error.response.data.ErrorCode === "403-SU"
    ) {
      // Support users access pending for the action.
      yield put(
        setNotification({
          message:
            "Access denied! Support user access is pending for the action performed.",
          severity: "error",
          open: true,
        })
      );
    } else {
      yield put(
        setNotification({
          message: "Something went wrong. Try again!",
          severity: "error",
          open: true,
        })
      );
    }
  } finally {
    yield put(resetAppLoading());
  }
}

function* fetchPosSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    // yield put(fetchPayment());

    const response = yield call(
      apiGetCall,
      `${URL}admin/payment-catalogue-pos`
    );

    yield put(fetchPosSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchPosFailure());
    yield put(
      setNotification({
        message: "Unable to fetch POS list.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* fetchFopSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const response = yield call(
      apiGetCall,
      `${URL}admin/payment-catalogue-types`
    );
    yield put(fetchFopSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchFopFailure());
    yield put(
      setNotification({
        message: "Unable to fetch form of payment list.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* addNewFopSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    const reqData = {
      paymentCode: action.payload.paymentCode,
      paymentName: action.payload.paymentName,
      comments: action.payload.comments,
    };

    const response = yield call(
      apiPostCallWithFullError,
      `${URL}admin/payment-catalogue-type`,
      reqData
    );

    if (response.status === "successful") {
      yield put(addNewFopSuccess(reqData));
      yield put(
        setNotification({
          message: "Form of Payment added successfully!",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchFop());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.error("Error adding new FOP:", error.response);
    const errorCode = error.response.status;
    if (errorCode) {
      yield put(addNewFopFailure());
      console.log(errorCode);
      console.log(error.response.data["Error"]);

      if (
        errorCode === 400 &&
        error.response.data["Error"] === "Invalid details"
      ) {
        yield put(
          setNotification({
            message: errorMessages[400],
            severity: "error",
            open: true,
          })
        );
      } else if (errorCode === 409) {
        yield put(
          setNotification({
            message: errorMessages[409],
            severity: "error",
            open: true,
          })
        );
      } else if (errorCode === 500) {
        yield put(
          setNotification({
            message: errorMessages[500],
            severity: "error",
            open: true,
          })
        );
      } else if (errorCode === 405) {
        yield put(
          setNotification({
            message: errorMessages[405],
            severity: "error",
            open: true,
          })
        );
      } else if (
        errorCode === 403 &&
        error.response.data.ErrorCode === "403-SU"
      ) {
        // Support users access pending for the action.
        yield put(
          setNotification({
            message:
              "Access denied! Support user access is pending for the action performed.",
            severity: "error",
            open: true,
          })
        );
      } else {
        yield put(
          setNotification({
            message: "Something went wrong. Try again!",
            severity: "error",
            open: true,
          })
        );
      }
    } else {
      yield put(addNewFopFailure());
      yield put(
        setNotification({
          message: "Something went wrong. Try again!",
          severity: "error",
          open: true,
        })
      );
    }
  } finally {
    yield put(resetAppLoading());
  }
}

function* addNewPosSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    const reqData = {
      pos: action.payload.pos,
      countryName: action.payload.countryName,
      comment: action.payload.comment,
    };

    const response = yield call(
      apiPostCallWithFullError,
      `${URL}admin/payment-catalogue-pos`,
      reqData
    );

    if (response.status === "successful") {
      yield put(addNewPosSuccess(reqData));
      yield put(
        setNotification({
          message: "Point of sale added successfully!",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchPos());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.error("Error adding new POS:", error);
    yield put(addNewPosFailure());

    const errorCode = error.response.status;
    console.log(errorCode);
    if (
      errorCode &&
      errorCode === 403 &&
      error.response.data.ErrorCode === "403-SU"
    ) {
      // Support users access pending for the action.
      yield put(
        setNotification({
          message:
            "Access denied! Support user access is pending for the action performed.",
          severity: "error",
          open: true,
        })
      );
    } else {
      yield put(
        setNotification({
          message: "Something went wrong. Try again!",
          severity: "error",
          open: true,
        })
      );
    }
  } finally {
    yield put(resetAppLoading());
  }
}

function* fetchAffectedItemsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { id } = action.payload;
    const response = yield call(
      apiGetCall,
      `${URL}admin/payment-catalogue-pos-search/${id}`
    );
    yield put(fetchAffectedItemsSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchAffectedItemsFailure());
    yield put(
      setNotification({
        message: "Unable to fetch affected items.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* fetchFopAffectedItemsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { id } = action.payload;
    const response = yield call(
      apiGetCall,
      `${URL}admin/payment-catalogue-type-search/${id}`
    );
    yield put(fetchFopAffectedItemsSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchFopAffectedItemsFailure());
    yield put(
      setNotification({
        message: "Unable to fetch affected items.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* deletePaymentSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const { comment, id } = action.payload.modalData;
    const response = yield call(
      apiDeleteCall,
      URL + "admin/payment-catalogue/" + id,
      {
        data: { comment },
      }
    );
    if (response.status === "Successful") {
      yield put(deletePaymentSuccess(response));
      yield put(
        setNotification({
          message: "Entry Deleted Successfully",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchPayment());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.log("error", error);
    yield put(deletePaymentFailure(error));
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* deletePOSSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const { comment, id } = action.payload.modalData;
    const response = yield call(
      apiDeleteCall,
      URL + "admin/payment-catalogue-pos/" + id,
      {
        data: { comment },
      }
    );
    if (response.status === "Successful") {
      yield put(deletePOSSuccess(response));
      yield put(
        setNotification({
          message: "Entry Deleted Successfully",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchPos());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.log("error", error);
    yield put(deletePOSFailure(error));
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* deleteFOPSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const { comment, id } = action.payload.modalData;
    const comments = comment;
    const response = yield call(
      apiDeleteCall,
      URL + "admin/payment-catalogue-type/" + id,
      {
        data: { comments },
      }
    );
    if (response.status === "Successful") {
      yield put(deleteFOPSuccess(response));
      yield put(
        setNotification({
          message: "Entry Deleted Successfully",
          severity: "success",
          open: true,
        })
      );
      yield put(fetchFop());
      yield put(fetchHistory());
    }
  } catch (error) {
    console.log("error", error);
    yield put(deleteFOPFailure(error));
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* fetchPaymentLogsSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const response = yield call(
      apiGetCall,
      `${URL}admin/payment-catalogue-history-logs`
    );
    yield put(fetchHistorySuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(fetchHistoryFailure());
    yield put(
      setNotification({
        message: "Unable to fetch payment history.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* sagas() {
  yield all([
    takeLatest(fetchPayment.type, fetchPaymentSaga),
    takeLatest(addNewMarket.type, addNewMarketSaga),
    takeLatest(fetchPos.type, fetchPosSaga),
    takeLatest(fetchFop.type, fetchFopSaga),
    takeLatest(addNewFop.type, addNewFopSaga),
    takeLatest(addNewPos.type, addNewPosSaga),
    takeLatest(putPayment.type, putPaymentCatalogueSaga),
    takeLatest(deletePayment.type, deletePaymentSaga),
    takeLatest(fetchAffectedItems.type, fetchAffectedItemsSaga),
    takeLatest(deletePOS.type, deletePOSSaga),
    takeLatest(fetchFopAffectedItems.type, fetchFopAffectedItemsSaga),
    takeLatest(deleteFOP.type, deleteFOPSaga),
    takeLatest(fetchHistory.type, fetchPaymentLogsSaga),
  ]);
}

export default sagas;
